// import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
// import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
// import { Box, Button, Grid, Typography } from "@mui/material";
// import React from "react";
// import { paginationStyles } from "../components/style";
// const Pagination = ({
//   currentPage,
//   setCurrentPage,
//   totalRecords,
//   pageSize,
// }) => {
//   const totalPages = Math.ceil(totalRecords / pageSize);
//   return (
//     <Box mt={2}>
//       <Grid container spacing={2}>
//         <Grid item xs={12} sm={12} md={5} lg={7} xl={7}>
//           <Typography
//             variant="body1"
//             component="p"
//             textAlign={"start"}
//             marginTop={6}
//             marginBottom={5}
//           >
//             Showing {pageSize} from {totalRecords} data
//           </Typography>
//         </Grid>
//         <Grid item xs={12} sm={12} md={7} lg={5} xl={5}>
//           <Box
//             className="button-box"
//             padding={{ xs: 1, sm: 3, md: 3, lg: 3, xl: 3 }}
//             display="flex"
//             justifyContent="end"
//           >
//             <Button
//               onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//               sx={paginationStyles.PreviousButton}
//               startIcon={
//                 <KeyboardDoubleArrowLeftIcon sx={{ fontSize: "10px" }} />
//               }
//               disabled={currentPage === 1}
//             >
//               Previous
//             </Button>
//             <Box sx={{ backgroundColor: "#E3E4EB", display: "flex" }}>
//               {/* {[1, 2].map((pageNumber) => ( */}
//               {Array.from({ length: totalPages }, (_, i) => i + 1).map(
//                 (pageNumber) => (
//                   <Button
//                     key={pageNumber}
//                     onClick={() => setCurrentPage(pageNumber)}
//                     sx={{
//                       backgroundColor:
//                         currentPage === pageNumber ? "#fff" : "#E3E4EB",
//                       color: currentPage === pageNumber ? "#000" : "#B6BEE8",
//                       ...paginationStyles.arrayButtons,
//                       "&:disabled": {
//                         backgroundColor: "#b6b7b8",
//                         color: "#fff",
//                       },
//                     }}
//                     disabled={pageNumber > totalPages}
//                   >
//                     {pageNumber}
//                   </Button>
//                 )
//               )}
//             </Box>
//             <Button
//               onClick={() =>
//                 setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//               }
//               sx={paginationStyles.nextButton}
//               endIcon={
//                 <KeyboardDoubleArrowRightIcon sx={{ fontSize: "10px" }} />
//               }
//               disabled={currentPage >= totalPages}
//             >
//               Next
//             </Button>
//           </Box>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };
// export default Pagination;

// import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
// import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
// import { Box, Button, Grid, Typography } from "@mui/material";
// import React, { useMemo } from "react";
// import { paginationStyles } from "../components/style";

// const Pagination = ({
//   currentPage,
//   setCurrentPage,
//   totalRecords,
//   pageSize,
// }) => {
//   const totalPages = Math.ceil(totalRecords / pageSize);
//   const maxVisiblePages = 4;

//   // Handle edge cases
//   const safeTotalPages = Math.max(totalPages, 1);
//   const safeCurrentPage = Math.max(Math.min(currentPage, safeTotalPages), 1);

//   const visiblePageStart =
//     Math.floor((safeCurrentPage - 1) / maxVisiblePages) * maxVisiblePages + 1;
//   const visiblePageEnd = Math.min(
//     visiblePageStart + maxVisiblePages - 1,
//     safeTotalPages
//   );

//   const visiblePages = useMemo(() => {
//     return Array.from(
//       { length: visiblePageEnd - visiblePageStart + 1 },
//       (_, i) => visiblePageStart + i
//     );
//   }, [visiblePageStart, visiblePageEnd]);

//   // Disable conditions
//   const isPreviousDisabled = safeCurrentPage <= 1 || totalRecords === 0;
//   const isNextDisabled = safeCurrentPage >= safeTotalPages || totalRecords === 0;

//   const handlePreviousClick = () => {
//     if (!isPreviousDisabled) {
//       setCurrentPage((prev) => Math.max(prev - 1, 1));
//     }
//   };

//   const handleNextClick = () => {
//     if (!isNextDisabled) {
//       setCurrentPage((prev) => Math.min(prev + 1, safeTotalPages));
//     }
//   };

//   return (
//     <Box mt={2}>
//       <Grid container spacing={2}>
//         <Grid item xs={12} sm={12} md={5} lg={7} xl={7}>
//           <Typography
//             variant="body1"
//             component="p"
//             textAlign="start"
//             mt={3}
//             mb={3}
//           >
//             Showing {Math.min(pageSize, totalRecords)} from {totalRecords} data
//           </Typography>
//         </Grid>
//         <Grid item xs={12} sm={12} md={7} lg={5} xl={5}>
//           <Box
//             className="button-box"
//             padding={{ xs: 1, sm: 3, md: 3, lg: 3, xl: 3 }}
//             display="flex"
//             justifyContent="end"
//           >
//             <Button
//               onClick={handlePreviousClick}
//               sx={paginationStyles.PreviousButton}
//               startIcon={
//                 <KeyboardDoubleArrowLeftIcon sx={{ fontSize: "10px" }} />
//               }
//               disabled={isPreviousDisabled}
//             >
//               Previous
//             </Button>
//             <Box
//               sx={{
//                 backgroundColor: "#E3E4EB",
//                 display: "flex",
//                 borderRadius: 1,
//               }}
//             >
//               {visiblePages.map((pageNumber) => (
//                 <Button
//                   key={pageNumber}
//                   onClick={() => setCurrentPage(pageNumber)}
//                   sx={{
//                     backgroundColor:
//                       safeCurrentPage === pageNumber ? "#fff" : "#E3E4EB",
//                     color: safeCurrentPage === pageNumber ? "#000" : "#B6BEE8",
//                     ...paginationStyles.arrayButtons,
//                     "&:disabled": {
//                       backgroundColor: "#b6b7b8",
//                       color: "#fff",
//                     },
//                   }}
//                   disabled={totalRecords === 0}
//                 >
//                   {pageNumber}
//                 </Button>
//               ))}
//             </Box>
//             <Button
//               onClick={handleNextClick}
//               sx={paginationStyles.nextButton}
//               endIcon={
//                 <KeyboardDoubleArrowRightIcon sx={{ fontSize: "10px" }} />
//               }
//               disabled={isNextDisabled}
//             >
//               Next
//             </Button>
//           </Box>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };

// export default Pagination;

import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useMemo } from "react";
import { paginationStyles } from "../components/style";

const Pagination = ({
  currentPage,
  setCurrentPage,
  totalRecords,
  pageSize,
}) => {
  const totalPages = Math.ceil(totalRecords / pageSize);
  const maxVisiblePages = 4;

  const safeTotalPages = Math.max(totalPages, 1);
  const safeCurrentPage = Math.max(Math.min(currentPage, safeTotalPages), 1);

  const visiblePageStart =
    Math.floor((safeCurrentPage - 1) / maxVisiblePages) * maxVisiblePages + 1;
  const visiblePageEnd = Math.min(
    visiblePageStart + maxVisiblePages - 1,
    safeTotalPages
  );

  const visiblePages = useMemo(() => {
    return Array.from(
      { length: visiblePageEnd - visiblePageStart + 1 },
      (_, i) => visiblePageStart + i
    );
  }, [visiblePageStart, visiblePageEnd]);

  const currentPageStart = (safeCurrentPage - 1) * pageSize + 1;
  const currentPageEnd = Math.min(safeCurrentPage * pageSize, totalRecords);

  const isPreviousDisabled = safeCurrentPage <= 1 || totalRecords === 0;
  const isNextDisabled =
    safeCurrentPage >= safeTotalPages || totalRecords === 0;

  const handlePreviousClick = () => {
    if (!isPreviousDisabled) {
      setCurrentPage((prev) => Math.max(prev - 1, 1));
    }
  };

  const handleNextClick = () => {
    if (!isNextDisabled) {
      setCurrentPage((prev) => Math.min(prev + 1, safeTotalPages));
    }
  };

  return (
    <Box mt={2}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={5} lg={7} xl={7}>
          <Typography
            variant="body1"
            component="p"
            textAlign="start"
            mt={3}
            mb={3}
          >
            {totalRecords === 0
              ? "No data available"
              : `Showing ${currentPageStart}-${currentPageEnd} of ${totalRecords} data`}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={7} lg={5} xl={5}>
          <Box
            className="button-box"
            padding={{ xs: 1, sm: 3, md: 3, lg: 3, xl: 3 }}
            display="flex"
            justifyContent="end"
          >
            <Button
              onClick={handlePreviousClick}
              sx={paginationStyles.PreviousButton}
              startIcon={
                <KeyboardDoubleArrowLeftIcon sx={{ fontSize: "10px" }} />
              }
              disabled={isPreviousDisabled}
            >
              Previous
            </Button>
            <Box
              sx={{
                backgroundColor: "#E3E4EB",
                display: "flex",
                borderRadius: 1,
              }}
            >
              {visiblePages.map((pageNumber) => (
                <Button
                  key={pageNumber}
                  onClick={() => setCurrentPage(pageNumber)}
                  sx={{
                    backgroundColor:
                      safeCurrentPage === pageNumber ? "#fff" : "#E3E4EB",
                    color: safeCurrentPage === pageNumber ? "#000" : "#B6BEE8",
                    ...paginationStyles.arrayButtons,
                    "&:disabled": {
                      backgroundColor: "#b6b7b8",
                      color: "#fff",
                    },
                  }}
                  disabled={totalRecords === 0}
                >
                  {pageNumber}
                </Button>
              ))}
            </Box>
            <Button
              onClick={handleNextClick}
              sx={paginationStyles.nextButton}
              endIcon={
                <KeyboardDoubleArrowRightIcon sx={{ fontSize: "10px" }} />
              }
              disabled={isNextDisabled}
            >
              Next
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Pagination;
